import { RouterPaths } from 'helpers/router-paths';
import { ContainerProps } from 'components/Container/Container';
import { ButtonOptionProps, ButtonsField } from 'ui/ButtonsField/ButtonsField';
import { generateOptions } from 'utils/options';

export const DOCUMENTS_PROPS: Partial<ContainerProps> = {
    activeItem: RouterPaths.CoursesAssignments
};

export const STATIC_DOCUMENTS_PROPS: Partial<ContainerProps> = {
    activeItem: RouterPaths.Documents
};

export const WORD_EXTENSION_OPTIONS: ButtonOptionProps<unknown | undefined>[] =
    [{ children: 'Зафиксировать', value: undefined }];

export const EXTENSIONS_OPTIONS: ButtonOptionProps<unknown>[] = [
    ...WORD_EXTENSION_OPTIONS
];

const FIELD_NAME = 'extensionType';

export const GenerateDocumentField = () => (
    <ButtonsField name={FIELD_NAME} options={EXTENSIONS_OPTIONS} />
);

export const GenerateWordField = () => (
    <ButtonsField name={FIELD_NAME} options={WORD_EXTENSION_OPTIONS} />
);

export const recipiencyDocumentsTypeOptions = generateOptions(
    'recipiencyDocumentsType'
);
